import { render, staticRenderFns } from "./DiscountsSettings.vue?vue&type=template&id=1e16a44a&"
import script from "./DiscountsSettings.vue?vue&type=script&lang=js&"
export * from "./DiscountsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports